import { gql } from '@apollo/client'

export const FOLLOW_CHANNEL = gql`
  mutation FollowChannel($input: FollowChannelInput!) {
    followChannel(input: $input) {
      channel {
        id
        followersCount
        viewerIsFollowing
      }
      errors
    }
  }
`

export const UNFOLLOW_CHANNEL = gql`
  mutation UnfollowChannel($input: UnfollowChannelInput!) {
    unfollowChannel(input: $input) {
      channel {
        id
        followersCount
        viewerIsFollowing
      }
      errors
    }
  }
`
